// removed by extract-text-webpack-plugin
module.exports = {"o-site-wrap":"_20fBr","oSiteWrap":"_20fBr","o-site-wrap--padding":"g1KKY","oSiteWrapPadding":"g1KKY","clearfix":"_3u3eY","header":"qBC5_ _3u3eY","header-container":"_1J2rq _20fBr g1KKY","headerContainer":"_1J2rq _20fBr g1KKY","logo-container":"_1ohNx","logoContainer":"_1ohNx","logo":"_3KiRB","menu":"whZPZ","active":"_2L3E_","item-inner":"_3XxwZ","itemInner":"_3XxwZ","header-icon":"_1DVyl","headerIcon":"_1DVyl","burger":"_3-MwC","burger1":"_2hT4U _3-MwC","burger2":"_2I_PJ _3-MwC","burger3":"_1fjZX _3-MwC","header-icon-text":"_2uvgi","headerIconText":"_2uvgi"};


//////////////////
// WEBPACK FOOTER
// ./blocks/Header/header.scss
// module id = 479
// module chunks = 0 1